import React,{useReducer} from 'react';
import TareaContext from './tareaContext';
import TareaReducer from './tareaReducer';
import clienteAxios from '../../config/axios'
 /* import {v4 as uuid} from "uuid"; */ 

import{TAREAS_PROYECTO,
        AGREGAR_TAREA,
        VALIDAR_TAREA,
        ELIMINAR_TAREA,
        /* ESTADO_TAREA, */
        TAREA_ACTUAL,
        ACTUALIZAR_TAREA,
        LIMPIAR_TAREA} from '../../types';

const TareaState = props => {
  /*  const tareas= [
        {nombre:'Elegir Plataforma', estado: true,proyectoId:1},
        {nombre:'Elegir Colores', estado: false, proyectoId:2},
        {nombre:'Elegir Plataformas de Pago', estado: false, proyectoId:3},
        {nombre:'Elegir Hosting', estado: true, proyectoId:4},
        {nombre:'Elegir Plataforma', estado: true,proyectoId:1},
        {nombre:'Elegir Colores', estado: false, proyectoId:2},
        {nombre:'Elegir Plataformas de Pago', estado: false, proyectoId:3},
        {nombre:'Elegir Hosting', estado: true, proyectoId:4},
        {nombre:'Elegir Plataforma', estado: true,proyectoId:1},
        {nombre:'Elegir Colores', estado: false, proyectoId:2},
        {nombre:'Elegir Plataformas de Pago', estado: false, proyectoId:3},
        {nombre:'Elegir Hosting', estado: true, proyectoId:4},
        {nombre:'Elegir Plataforma', estado: true,proyectoId:3}
        
    ]; */

    const initialState={
         /* tareas: [
            {id:1, nombre:'Elegir Plataforma', estado: true, proyectoId:1},
            {id:2, nombre:'Elegir Colores', estado: false, proyectoId:1},
            {id:3, nombre:'Elegir Plataformas de Pago', estado: false, proyectoId:1},
            {id:4, nombre:'Elegir Hosting', estado: true, proyectoId:2},
            {id:5, nombre:'Elegir Plataforma', estado: true, proyectoId:2},
            {id:6, nombre:'Elegir Colores', estado: false, proyectoId:2},
            {id:7, nombre:'Elegir Plataformas de Pago', estado: false, proyectoId:3},
            {id:8, nombre:'Elegir Hosting', estado: true, proyectoId:3},
            {id:9, nombre:'Elegir Plataforma', estado: true, proyectoId:3},
            {id:10, nombre:'Elegir Colores', estado: false, proyectoId:4},
            {id:11, nombre:'Elegir Plataformas de Pago', estado: false, proyectoId:4},
            {id:12, nombre:'Elegir Hosting', estado: true, proyectoId:4},
            {id:13, nombre:'Elegir Plataforma', estado: true, proyectoId:4}
        ], */
        tareasproyecto: [],
        errortarea: false,
        tareaSeleccionada: null
    };

    //crear dispatch y state
    const [state, dispatch] = useReducer(TareaReducer, initialState);


    
     //obtenerlos tareas de un proyecto
     const obtenerTareas=async proyecto=>{
        /* console.log(proyecto) */
        try {
            const resultado= await clienteAxios.get('/api/tareas', {params: {proyecto}});
            /* console.log(resultado) */
            dispatch({
                type:TAREAS_PROYECTO, 
                payload: resultado.data.tareas 
            })
        } catch (error) {
            console.log(error)
        }
     }

     // agregar o crear una tarea al proyecto seleccionadp

     const agregarTarea = async tarea=>{
        /*  tarea.id = uuid();  */
        /* console.log(tarea) */
      try {
          const resultado= await clienteAxios.post('/api/tareas', tarea);
          console.log(resultado)
        dispatch({
            type: AGREGAR_TAREA,
            payload: tarea

        })
      } catch (error) {
          console.log(error)
      }
     }

     //valida y muestra un error en caso de que sea necesario

     const validarTarea=()=>{
         dispatch({
             type:VALIDAR_TAREA
         })
     }
    
     //eliminar tarea por su id
     const eliminarTarea= async (id,proyecto) =>{
       try {
         await clienteAxios.delete(`/api/tareas/${id}`, {params :{proyecto}});
        dispatch({
            type: ELIMINAR_TAREA,
            payload: id
        })
       } catch (error) {
           console.log(error)
       }
     }

     //cabambia el estado de cada tarea
   /*  const cambiarEstadotarea=tarea=>{
        dispatch({
            type: ESTADO_TAREA,
            payload: tarea
        })
    } */ //se une con actualiar tarea despues de que el backend esta listo

    //Extrae una tarea para edición
    const guardarTareaActual=tarea=>{
        dispatch({
            type:TAREA_ACTUAL,
            payload:tarea
        })
    }

    //EDITA O MODIFICA UNA TAREA
    const actualizarTarea= async tarea=>{
        /* console.log(tarea); */
        
        try {

            const resultado= await clienteAxios.put(`/api/tareas/${tarea._id}`,tarea);
            
            console.log(resultado);
            dispatch({
                type:ACTUALIZAR_TAREA,
                /* payload: tarea */
                payload: resultado.data.tarea
    
            })
        } catch (error) {
            console.log(error);
        }
    }

    //elimina la tarea seleccionada
    const limpiarTarea=()=>{
        dispatch({
            type:LIMPIAR_TAREA
        })
    }

    return ( 
        <TareaContext.Provider
            value={{
                tareasproyecto: state.tareasproyecto,
                errortarea: state.errortarea,
                tareaSeleccionada: state.tareaSeleccionada,
                obtenerTareas,
                agregarTarea,
                validarTarea,
                eliminarTarea,/* 
                cambiarEstadotarea, */
                guardarTareaActual,
                actualizarTarea,
                limpiarTarea 
            }}
        >
            {props.children}
        </TareaContext.Provider>
     );
}
 
export default TareaState;